export const createMemberForEmptyGroup = (groupId: string, groupName: string) => ({
  id: `empty-member-${groupId}`,
  firstName: '',
  lastName: '',
  email: '',
  groupId,
  groupName,
  searchField: '',
  status: 'accepted' as const,
});
